<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light evalution-main-color evalution-header">
      <div class="col col-sm-6">
        <a class="mr-4 text-light h2" href="#">{{this.config.projectName}}</a>
        <span class="text-light evalution-header-text"></span>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'DeliveryEvaluationHeader',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DeliveryEvaluationHeader.vue